<!-- Content -->
<div
  class="content container-fluid"
  [ngClass]="{ 'm-0 p-0': hideHeaderSections }"
>
  <!-- Page Header -->
  <header class="page-header mt-3" [hidden]="hideHeaderSections">
    <nav aria-label="breadcrumb" *ngIf="!createBookingFromSchedule">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">
          {{ 'general.create' | translate }}
        </li>
      </ol>
    </nav>

    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ 'bookingModule.createBookings' | translate }}
      </h1>
    </div>
  </header>

  <!-- End Page Header -->

  <!-- Step -->
  <ul
    *ngIf="!createBookingFromSchedule"
    class="step my-3 my-md-5"
    [hidden]="hideHeaderSections"
  >
    <li
      class="step-item cursor-pointer"
      [ngClass]="{ active: activeTab === 'bookingType' }"
      (click)="activeTab = 'bookingType'"
    >
      <span class="step-content-wrapper">
        <span class="step-icon">1</span>
        <div class="step-content">
          <span class="step-title">
            {{ 'bookingModule.bookingType' | translate }}
          </span>
        </div>
      </span>
    </li>
    <li
      class="step-item cursor-pointer"
      [ngClass]="{ active: activeTab === 'generalForm' }"
      (click)="activeTab = 'generalForm'"
    >
      <span class="step-content-wrapper">
        <span class="step-icon">2</span>
        <div class="step-content">
          <span class="step-title">
            {{ 'general.create' | translate }}
          </span>
        </div>
      </span>
    </li>
  </ul>
  <!-- End Step -->
  <form>
    <section
      [ngClass]="{
        card: !hideHeaderSections
      }"
    >
      <div
        class="card-header"
        *ngIf="!createBookingFromSchedule"
        [hidden]="hideHeaderSections"
      >
        <h3 class="card-title" *ngIf="activeTab == 'bookingType'">
          {{ 'bookingModule.bookingType' | translate }}
        </h3>
        <h3 class="card-title" *ngIf="activeTab == 'generalForm'">
          {{ 'bookingModule.createBooking' | translate }}
        </h3>
        <h3 class="card-title" *ngIf="activeTab == 'repeatForm'">
          {{ 'bookingModule.repeatBooking' | translate }}
        </h3>
      </div>
      <div class="card-body">
        <!-- Booking type -->

        <div
          class="row justify-content-center row-cols-md-2 row-cols-lg-3"
          *ngIf="activeTab == 'bookingType' && !createBookingFromSchedule"
        >
          <div class="col">
            <button
              type="button"
              class="h-100 btn btn-ghost-primary text-body"
              (click)="onSelectType(BookingCreationType.DEFAULT)"
            >
              <span class="text-center mx-3 d-block">
                <i
                  role="img"
                  class="my-5 fa fa-square fa-3x text-primary"
                  aria-hidden="true"
                ></i>
              </span>
              <span class="text-center m-3 d-block">
                <small class="text-cap">{{
                  'bookingModule.activityOnResource' | translate
                }}</small>
                <span
                  class="d-block display-4 text-dark mb-2"
                  data-test-id="create-booking-type-default-activity-resource-button"
                >
                  {{ 'bookingModule.default' | translate }}
                </span>
              </span>
              <span class="text-center mx-3 d-block">
                {{ 'bookingModule.bookingActivityDescription' | translate }}
              </span>
            </button>
          </div>

          <div class="col">
            <button
              type="button"
              class="h-100 btn btn-ghost-primary text-body"
              (click)="onSelectType(BookingCreationType.MULTI_ACTIVITY)"
            >
              <span class="text-center mx-3 d-block">
                <i
                  role="img"
                  class="fa fa-clipboard-check my-5 fa-3x text-primary"
                  aria-hidden="true"
                ></i>
              </span>
              <span class="text-center m-3 d-block">
                <small class="text-cap">
                  {{ 'bookingModule.manyActivities' | translate }}</small
                >
                <span
                  class="d-block display-4 text-dark mb-2"
                  data-test-id="create-booking-type-potencial-activities-button"
                >
                  {{ 'bookingModule.potentialActivities' | translate }}
                </span>
              </span>
              <span class="text-center mx-3 d-block">
                {{
                  'bookingModule.bookingPotentialActivityDescription'
                    | translate
                }}
              </span>
            </button>
          </div>

          <div class="col">
            <button
              type="button"
              class="h-100 btn btn-ghost-primary text-body"
              (click)="onSelectType(BookingCreationType.RESOURCE)"
            >
              <span class="text-center mx-3 d-block">
                <i
                  role="img"
                  class="fa fa-cube text-primary fa-3x my-5"
                  aria-hidden="true"
                ></i>
              </span>
              <span class="text-center m-3 d-block">
                <small class="text-cap">
                  {{ 'general.aSpace' | translate }}</small
                >
                <span
                  data-test-id="create-booking-type-resource"
                  class="d-block display-4 text-dark mb-2"
                >
                  Resource
                </span>
              </span>
            </button>
          </div>
        </div>
        <div
          class="row"
          *ngIf="activeTab == 'generalForm' || createBookingFromSchedule"
        >
          <div class="col-lg-4 col-xl-3">
            <booking-multi-create-form
              [resetRepeatForm$]="resetRepeatForm$"
              [resetSupervisorBookingsData$]="
                resetSupervisorBookingsData$ | async
              "
              (onValueChanges)="onValueChangesEvent($event)"
              [showApplyYearCalendar]="true"
              [booking]="bookingPartial"
              [linkedProductChange$]="linkedProductChange$"
              [selectedDate$]="selectedDate$"
              [selectedBookingCreateType]="selectedBookingCreateType"
              [form]="form"
              [wantApplyYearMatrix]="wantApplyYearMatrix"
              [repeatBooking]="isRepeat"
              [formOfRepeatFormRepeat]="formRepeatConfig"
              [bookingOfRepeatFormRepeat]="bookingPartial"
              [assignSupervisor]="assignSupervisor"
              [disableAssignSupervisorButtons]="disableComponent()"
              [disableRepeatBookingButtons]="disableComponent()"
              [createBookingFromSchedule]="createBookingFromSchedule"
              [arraySupervisors]="supervisorAssign?.arraySupervisor"
              [showRepeatForm]="showRepeatForm"
              [courseProduct]="courseProduct$ | async"
              (onApplyYearCalendar)="applyYearCalendar($event)"
              (onOpenModalRepeatbookings)="openModalRepeatbookings($event)"
              (onClickCancelButtonRepeat)="clickOnCancelButton()"
              (onClickOnSaveButtonRepeat)="clickOnSaveButton($event)"
              (onSetSelectedFormInBooKingFormRepeat)="
                setSelectedFormInBooKingFormRepeat()
              "
              (onClickOpenModalAssignSupervisor)="
                openModalAssignSupervisor($event)
              "
              (onDateAdjustment)="onDateAdjustment($event)"
            >
            </booking-multi-create-form>
          </div>
          <div class="col-lg-8 col-xl-9">
            <calendar
              [showDisableDate]="wantApplyYearMatrix"
              (onClickEvent)="onClickEvent($event)"
              (onChangeDates)="onChangeDates($event)"
              (onClickDate)="onClickDate($event)"
              [events]="calendarEvents$ | async"
              [stopLoading]="stopLoading"
            ></calendar>
          </div>

          <div
            class="spinner-border"
            role="status"
            *ngIf="(isLoading$ | async) && !stopLoading"
            attr.aria-label="{{ 'general.loading' | translate }}"
          >
          </div>
        </div>
        <div
          class="form-footer sticky-bottom"
          *ngIf="activeTab == 'generalForm' || createBookingFromSchedule"
        >
          <button
            data-test-id="create-booking-save-button"
            type="button"
            class="btn btn-primary btn-lg"
            [disabled]="
              ((isLoading$ | async) && !stopLoading) ||
              (isRepeat && formRepeatConfig.invalid)
            "
            (click)="onFinishButton()"
          >
            {{ 'general.save' | translate }}
          </button>
        </div>
      </div>
    </section>
  </form>
  <!-- Modal -->
  <div
    *ngIf="showCreatedBookingsModal"
    class="modal fade show d-block"
    data-test-id="created-bookings-modal"
    id="createdBookingsModal"
    tabindex="-1"
    aria-labelledby="createdBookingsModalLabel"
    [attr.aria-hidden]="!showCreatedBookingsModal"
    style="background: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h3 class="modal-title" id="createdBookingsModalLabel">
            {{ 'bookingModule.createdBookings' | translate }}
          </h3>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            attr.aria-label="{{ 'general.close' | translate }}"
            (click)="showCreatedBookingsModal = false"
          ></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <booking-table
            [tableData]="createdBookings"
            [showStatus]="false"
            [showPageFooter]="false"
            [showTotal]="false"
            (onClickRow)="onClickRow($event)"
          ></booking-table>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button
            data-test-id="close-created-button-modal"
            type="button"
            class="btn btn-soft-primary"
            data-bs-dismiss="modal"
            (click)="showCreatedBookingsModal = false"
          >
            {{ 'general.close' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
